import * as BIP322 from 'bip322-js';
import Verifier from 'bip322-js/dist/Verifier';

console.log('index.js geladen, Version: 2025-05-31-v11'); // Neue Version
console.log('BIP322-Modul:', BIP322);
console.log('BIP322 exports:', Object.keys(BIP322 || {}));
console.log('BIP322.Verifier:', BIP322?.Verifier);
console.log('BIP322.Verifier.verifySignature verfügbar:', typeof BIP322?.Verifier?.verifySignature);
console.log('Direkter Verifier Import:', Verifier);
console.log('Direkter Verifier.verifySignature verfügbar:', typeof Verifier?.verifySignature);

console.log('Buffer importiert in index.js:', typeof Buffer !== 'undefined');
console.log('Buffer.alloc verfügbar:', typeof Buffer?.alloc === 'function');
window.BIP322 = BIP322;
window.Verifier = Verifier;
window.Buffer = Buffer;

if (true) {
  console.log('Buffer-Modul in index.js verfügbar:', typeof Buffer !== 'undefined');
  console.log('window.Buffer nach Zuweisung:', !!window.Buffer);
}